<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :tree-config="treeConfig"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.resAttributeStatus === 'Y' ? 'light' : 'warning'"
        >
            {{row.resAttributeStatusName}}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'detail',
                  params: row,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="allow('M')"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'edit',
                  params: row,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-show="row.resAttributeStatus != 'N'"
            v-if="allow('D')"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.resAttributeCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l("INDEX.tips_no_data") || "暂无数据！" }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from "@/mixins/table-auto-height";

export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      type: Object,
      default: () => {},
    },
    loading: {
      default: false,
    },
  },
  components: {},
  data() {
    return {
      treeConfig: {},
      tableToolbar: {
        slots: {
          buttons: "toolbar_form",
        },
        refresh: {
          query: () => this.$emit("reload"),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: [
        {
          field: "seq",
          width: 50,
          align: "center",
          fixed: "left",
          type: "seq",
        },
        {
          field: "col-opt",
          title: this.$l("INDEX.table_label_operation") || "操作",
          headerAlign: "center",
          align: "left",
          fixed: "left",
          width: 110,
          slots: {
            default: "opt",
          },
        },
        {
          field: "resAttributeType",
          align: "center",
          width: 150,
          title: this.$l("table_label_attribute_type") || "属性类型",
          showHeaderOverflow: "title",
          showOverflow: "ellipsis",
        },
        {
          field: "resAttributeName",
          align: "center",
          width: 200,
          title: this.$l("table_label_name_cn") || "中文名称",
          showHeaderOverflow: "title",
          showOverflow: "ellipsis",
        },
        {
          field: "resAttributeNameEn",
          align: "center",
          width: 200,
          title: this.$l("table_label_name_en") || "英文名称",
          showHeaderOverflow: "title",
          showOverflow: "ellipsis",
        },
        {
          field: "resAttributeDescription",
          align: "center",
          minWidth: 250,
          title: this.$l("table_label_attribute_description") || "属性说明",
          showHeaderOverflow: "title",
          showOverflow: "ellipsis",
        },
        {
          field: "resAttributeStatus",
          align: "center",
          width: 100,
          title: this.$l("table_label_status") || "有效状态",
          slots: { default: "status" },
          showHeaderOverflow: "title",
          showOverflow: "ellipsis",
        },
      ],
    };
  },
  methods: {
    del(code) {
      this.$confirm(
        this.$l("INDEX.tips_delete") || "确认要删除该记录吗？",
        this.$l("INDEX.label_completeDesc") || "确认信息",
        {
          confirmButtonText:
            this.$l("INDEX.product_dialog_btn_confirm") || "确定",
          cancelButtonText: this.$l("INDEX.btn_cancel") || "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$api
            .delResearchDictionaryApi({ resAttributeCodeList: [code] })
            .then((res) => {
              this.$message({
                showClose: true,
                message: this.$l("INDEX.tips_delete_ok") || res.msg,
                type: "success",
              });
              this.$emit("reload");
            });
        })
        .catch(() => {});
    },
  },
};
</script>
